export default __webpack_public_path__ + "static/media/1983.1621e20e.png";